// Multivariate Dependencies
import React from 'react';
// Components
import { Container } from '../../../common/styles/container';
import { Badge } from '../../../atoms/Badge';
export var BadgeCellStructure = function (_a) {
    var className = _a.className, styleVariant = _a.styleVariant, value = _a.value, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, shape = _a.shape;
    return (React.createElement(Container, { className: className, as: 'td' },
        React.createElement(Badge, { size: 'small', styleVariant: styleVariant, shape: shape, rightIcon: rightIcon, leftIcon: leftIcon }, value)));
};
//# sourceMappingURL=BadgeCellStructure.js.map